export const initAdCarousel = () => {

    /**
     * Encapsulates the logic for a single carousel instance.
     * @param {HTMLElement} carouselContainer The root element of the carousel.
     * @returns {{setContainerHeight: function}} An object with a public method for height adjustment.
     */

    function delROSAd(carouselContainer) {
        const slides = carouselContainer.querySelectorAll('.carousel-item');

        if (slides.length > 1) {
            const elementsToDelete = carouselContainer.querySelectorAll('.carousel-item.run-of-site');
            if (slides.length != elementsToDelete.length) {
                elementsToDelete.forEach(element => {
                    // The same logic applies as client-side JavaScript
                    if (element.parentNode) {
                        element.parentNode.removeChild(element);
                    }
                });
            }
            
        }
        const validSlides = carouselContainer.querySelectorAll('.carousel-item');
        return validSlides

    }

    function initializeCarousel(carouselContainer) {
        /* const slides = carouselContainer.querySelectorAll('.carousel-item'); */
        const slides = delROSAd(carouselContainer);
        if (slides.length === 0) return { setContainerHeight: () => { } }; // Return dummy if no slides
   
        let currentSlide = Math.floor(Math.random() * slides.length);
 

        /**
         * Dynamically sets this carousel container's height based on its active slide.
         */
        function setContainerHeight() {
            // Ensure only one slide is marked 'active' for height calculation
            const activeSlide = slides[currentSlide];

            if (activeSlide) {
                // Get the total rendered height of the active slide content (image + caption)
                const height = activeSlide.offsetHeight;

                // Apply the height to the container element
                carouselContainer.style.height = `${height}px`;
            }
        }

        /**
         * Updates the carousel to display a specific slide index.
         * @param {number} n The index of the slide to display.
         */
        function showSlide(n) {
            // Calculate the new index, ensuring it loops around
            currentSlide = (n + slides.length) % slides.length;
          

            // 1. Update Slides (Remove active class from all, add to current)
            slides.forEach((slide, index) => {
                slide.classList.remove('carousel-active');

                if (index === currentSlide) {
                    slide.classList.add('carousel-active');
                }
            });

        }

        // --- Local Initialization ---

        //  Initial display and height calculation
        showSlide(currentSlide);

        // Expose the setContainerHeight function for external use (like the window resize listener)
        return { setContainerHeight };
    }

    window.onload = function () {
        // Find all elements with the common class name
        const allCarousels = document.querySelectorAll('.carousel-container');

        // Initialize each carousel independently
        allCarousels.forEach((container, index) => {
            initializeCarousel(container);
        });

    };
};
